<form [formGroup]="formGroup!" class="signin" data-testid="sign-in-container">

  <app-modal-option-panel>
    <div class="modal-option-panel__stack">
      <div class="input-el">
        <input placeholder="Email" name="email" formControlName="loginEmail" type="email" data-testid="sign-in-email-input">
      </div>
      <div class="input-el">
        <div class="password-field">
          <input class="password-input" name="current-password"
            data-testid="sign-in-password-input"
            [placeholder]="languageService.languageJSON.Global_Password" formControlName="loginPassword"
            [type]="showPassword ? 'text' : 'password'">
          <button type="button" class="password-toggle"
            data-testid="sign-in-password-toggle-btn"
            [ngClass]="showPassword ? 'password-eye-off' : 'password-eye-on'" (click)="togglePassword()"
            tabindex="-1" aria-label="Toggle password visibility"></button>
        </div>
      </div>
      <div class="input-el checkbox remember-me">
        <mat-checkbox formControlName="rememberMe" data-testid="sign-in-remember-me-checkbox">{{
          languageService.languageJSON.AccountDialog_RememberMe }}</mat-checkbox>
      </div>
      @if (firstStepError!='') {
        <div class="input-el">
          <h5 class="error-text">{{ firstStepError }}</h5>
        </div>
      }
      <div class="input-el">
        <button class="account-btn" (click)="signIn.emit()" data-testid="sign-in-submit-btn">{{
          languageService.languageJSON.AccountDialog_SignIn }}</button>
      </div>
      <div class="input-el">
        <h5 class="forgot-password" (click)="forgotPassword.emit()" data-testid="sign-in-forgot-password-link">{{
          languageService.languageJSON.AccountDialog_ForgotYourPassword }}</h5>
      </div>
      <div class="input-el social-row">
        <button class="account-btn google-btn social-icon-btn" (click)="accountService.signInWithGoogle()"
          data-testid="sign-in-google-btn"
          [title]="languageService.languageJSON.AccountDialog_SignIn_Google">
          <img src="assets/icons/default/social/google_icon.svg" />
        </button>
        <button class="account-btn facebook-btn social-icon-btn" (click)="accountService.signInWithFacebook()"
          data-testid="sign-in-facebook-btn"
          [title]="languageService.languageJSON.AccountDialog_SignIn_Facebook">
          <img src="assets/icons/default/social/facebook_icon.svg" />
        </button>
        @if (!preiOS13WebView && !androidWebView) {
          <button class="account-btn apple-btn social-icon-btn" (click)="accountService.signInWithApple()"
            data-testid="sign-in-apple-btn"
            [title]="languageService.languageJSON.AccountDialog_SignIn_Apple">
            <img [src]="'assets/icons/' + settingsService.getMap().Skin + '/social/apple_logo.svg'" />
          </button>
        }
      </div>
      <div class="input-el">
        <button class="account-btn" (click)="register.emit()" data-testid="sign-in-register-btn">{{
          languageService.languageJSON.AccountDialog_Register }}</button>
      </div>
    </div>
  </app-modal-option-panel>
</form>
